<template>
  <div class="w-full h-screen   flex justify-center bg-form-box items-center px-2">
    <FormUserPass />
  </div>
</template>



<script setup lang="ts">
import FormUserPass from '@/components/base/FormUserPass.vue';

</script>
